import { assertTokenValidForMutation, handleResponse } from "./service-helpers";

const NBH_AGE_THRESHOLD_ADMIN_URL = `${import.meta.env.VITE_NBH_URL_ROOT}/api/admin/organization-settings/age-highlight-threshold`;
const NBH_AGE_THRESHOLD_USER_URL = `${import.meta.env.VITE_NBH_URL_ROOT}/api/options/age-highlight-threshold`;

export interface AgeHighlightThresholdResponse {
    threshold: number;
}

export async function getAgeHighlightThreshold(token: string): Promise<number> {
    const response = await fetch(NBH_AGE_THRESHOLD_USER_URL, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });

    const data = await handleResponse<AgeHighlightThresholdResponse>(response) as AgeHighlightThresholdResponse;
    return data.threshold;
}

export async function updateAgeHighlightThreshold(token: string, threshold: number): Promise<number> {
    assertTokenValidForMutation()
    const response = await fetch(NBH_AGE_THRESHOLD_ADMIN_URL, {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ threshold })
    });

    const data = await handleResponse<AgeHighlightThresholdResponse>(response) as AgeHighlightThresholdResponse;
    return data.threshold;
}